<template>
  <ul class="absolute z-0 pin-b invisible">
    <li v-for="page in content" :key="page.id">
      <img width="1" height="1" v-for="(map, index) in page.content.maps" :key="index+'-n'" :src="map.north"/>
      <img width="1" height="1" v-for="(map, index) in page.content.maps" :key="index+'-s'" :src="map.south"/>
      <img width="1" height="1" v-for="(gallery, index) in page.content.gallery" :key="index+'-i'" :src="gallery.url"/>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'PreloadImages',

  computed: {
    content () {
      let content = this.$store.getters['pages/content']
      return content.filter(page => page.type !== 'heading')
    }
  }
}
</script>
